import DestructibleType from "../enums/DestructibleType";
import EnemyType from "../enums/EnemyType";
import StageEventType from "../enums/StageEventType";
import StageType from "../enums/StageType";
import { FormationConfig } from "../game/formations/BaseFormation";
import STAGES_GREEN from "./STAGES_GREEN";

export interface StageEvent {
  eventType: StageEventType;
  delay: number;
  repeat: number;
  // The smaller the value, the easier it is to refresh
  chance?: any;
  duration?: number;
}

export interface StageData {
  stageNameKey?: string;
  descriptionKey?: string;
  imageKey?: string;
  unlocked?: boolean;
  hidden?: boolean;
  startingSpawns?: number;
  minute?: number; // Can be 0, 0.5, 1, 1.5, etc.
  destructibleType?: DestructibleType;
  destructibleFreq?: number;
  destructibleChance?: number;
  destructibleChanceMax?: number;
  maxDestructibles?: number;
  minimum?: number;
  frequency?: number;
  bosses?: EnemyType[];
  enemies?: EnemyType[];
  events?: StageEvent[];
  formations?: FormationConfig[];
}

// Default camel caravan event that spawns every 0.5 minutes
export const DEFAULT_CAMEL_CARAVAN_EVENT: StageEvent = {
  eventType: StageEventType.CAMEL_CARAVAN,
  delay: 10000,
  repeat: 2,
  chance: 100,
} as const;

const STAGES_UNSAFE: Partial<Record<StageType, StageData[]>> = {
  [StageType.DESERT1]: [
    //desert border
    {
      stageNameKey: "stages.desert1.name",
      descriptionKey: "stages.desert1.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      startingSpawns: 1,
      minute: 0,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 5,
      frequency: 400,
      enemies: [EnemyType.SMALL_HAMSTER1],
      formations: [
        {
          enemyType: EnemyType.SMALL_HAMSTER1,
          enemyCount: 27,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 500,
          showPointerAfterMinute: 0,
        },
      ],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 5,
      frequency: 250,
      enemies: [EnemyType.SMALL_HAMSTER1],
      events: [],
    },
    {
      minute: 1,
      minimum: 20,
      frequency: 350,
      enemies: [EnemyType.SMALL_HAMSTER1],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 1.5,
      minimum: 20,
      frequency: 350,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 3,
          chance: 80,
        },
      ],
    },
    {
      minute: 2,
      minimum: 10,
      frequency: 350,
      enemies: [EnemyType.FAT_HAMSTER],
      //bosses: [EnemyType.SUIT_HAMSTER],
      bosses: [EnemyType.DEATH],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    /* {
      minute: 2.5,
      minimum: 20,
      frequency: 350,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 3,
      minimum: 10,
      frequency: 150,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 3.5,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 4,
      minimum: 10,
      frequency: 250,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SNAKE1],
      bosses: [],
    },
    {
      minute: 4.5,
      minimum: 30,
      frequency: 250,
      enemies: [EnemyType.CACTUS, EnemyType.SNAKE1, EnemyType.FAT_HAMSTER],
      bosses: [],
    },
    {
      minute: 5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.DEATH],
    },*/
  ],
  [StageType.DESERT2]: [
    //meet the bosses band
    {
      stageNameKey: "stages.desert1.name",
      descriptionKey: "stages.desert1.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      startingSpawns: 1,
      minute: 0,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 20,
      frequency: 250,
      enemies: [EnemyType.SMALL_HAMSTER1],
      formations: [
        {
          enemyType: EnemyType.SMALL_HAMSTER2,
          enemyCount: 27,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 2000,
          showPointerAfterMinute: 0,
        },
      ],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 15,
      frequency: 50,
      enemies: [EnemyType.SMALL_HAMSTER1],
      events: [],
    },
    {
      minute: 1,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.SMALL_HAMSTER1, EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 4000,
          repeat: 5,
          chance: 80,
        },
      ],
    },
    {
      minute: 1.5,
      minimum: 10,
      frequency: 200,
      enemies: [EnemyType.SMALL_HAMSTER1, EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 2,
      minimum: 10,
      frequency: 200,
      enemies: [EnemyType.SMALL_HAMSTER1, EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.SUIT_HAMSTER],
      //bosses: [EnemyType.SUIT_HAMSTER, EnemyType.SUIT_HAMSTER, EnemyType.SUIT_HAMSTER],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 60,
        },
      ],
    },
    {
      minute: 2.5,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 3,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 3.5,
      minimum: 30,
      frequency: 200,
      enemies: [EnemyType.SNAKE1, EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 4,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.SNAKE1, EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 4.5,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.CACTUS],
      bosses: [],
      events: [],
    },
    {
      minute: 5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.SNAKE1, EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.DEATH],
      events: [],
    },
    /*{
      minute: 5.5,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 6,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 6.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.SNAKE1],
      bosses: [],
      events: [],
    },
    {
      minute: 7,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.SNAKE1],
      bosses: [],
      events: [],
    },
    {
      minute: 7.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 8,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SNAKE2],
      bosses: [],
      events: [],
    },
    {
      minute: 8.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.SNAKE2],
      bosses: [],
      events: [],
    },
    {
      minute: 9,
      minimum: 10,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.DEATH],
      events: [],
    },*/
  ],

  //Desert 3, hidden treasure
  [StageType.DESERT3]: [
    {
      stageNameKey: "stages.desert1.name",
      descriptionKey: "stages.desert1.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      startingSpawns: 1,
      minute: 0,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 10,
      frequency: 50,
      enemies: [EnemyType.SMALL_HAMSTER2],
      formations: [
        {
          enemyType: EnemyType.SNAKE1,
          enemyCount: 27,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 10000,
          showPointerAfterMinute: 0,
        },
      ],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.SMALL_HAMSTER2, EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 1,
      minimum: 10,
      frequency: 250,
      enemies: [
        EnemyType.SMALL_HAMSTER2,
        EnemyType.FAT_HAMSTER,
        EnemyType.SCORPION,
      ],
      events: [],
    },
    {
      minute: 1.5,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SMALL_HAMSTER2],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 4000,
          repeat: 5,
          chance: 80,
        },
      ],
    },
    {
      minute: 2,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.SMALL_HAMSTER2, EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.SCORPION_BOSS],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 60,
        },
      ],
    },
    {
      minute: 2.5,
      minimum: 15,
      frequency: 150,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SNAKE1],
      events: [],
    },
    {
      minute: 3,
      minimum: 15,
      frequency: 100,
      enemies: [EnemyType.SNAKE1, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 3.5,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.SNAKE1, EnemyType.CACTUS],
      events: [],
    },
    {
      minute: 4,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.SNAKE1, EnemyType.CACTUS],
      bosses: [],
      events: [],
    },
    {
      minute: 4.5,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.CACTUS],
      bosses: [EnemyType.SUIT_HAMSTER],
      events: [],
    },
    {
      minute: 5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 5.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.FAT_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 6,
      minimum: 25,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.FAT_HAMSTER, EnemyType.SCORPION],
      bosses: [EnemyType.SUIT_HAMSTER],
      events: [],
    },
    {
      minute: 6.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS],
      bosses: [],
      events: [],
    },
    {
      minute: 7,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS],
      bosses: [],
      events: [],
    },
    {
      minute: 7.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS],
      bosses: [],
      events: [],
    },
    {
      minute: 8,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.SNAKE2],
      bosses: [],
      events: [],
    },
    {
      minute: 8.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.SNAKE2],
      bosses: [],
      events: [],
    },
    {
      minute: 9,
      minimum: 10,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.DEATH],
      events: [],
    },
  ],

  //DESERT 4, 10 mins level
  [StageType.DESERT4]: [
    //original level 1
    {
      stageNameKey: "stages.desert1.name",
      descriptionKey: "stages.desert1.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      startingSpawns: 3,
      minute: 0,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 10,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER],
      formations: [
        {
          enemyType: EnemyType.FAT_HAMSTER,
          enemyCount: 27,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 1000,
          showPointerAfterMinute: 0,
        },
        {
          enemyType: EnemyType.SNAKE1,
          enemyCount: 30,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 10000,
          showPointerAfterMinute: 2,
        },
      ],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 15,
      frequency: 100,
      enemies: [EnemyType.SNAKE1, EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 1,
      minimum: 15,
      frequency: 100,
      enemies: [EnemyType.SMALL_HAMSTER1, EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.SUIT_HAMSTER],
      events: [],
    },
    {
      minute: 1.5,
      minimum: 15,
      frequency: 50,
      enemies: [EnemyType.SNAKE1],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 2,
      minimum: 10,
      frequency: 100,
      enemies: [EnemyType.SCORPION, EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 2.5,
      minimum: 10,
      frequency: 50,
      enemies: [EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 3,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 3.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.SCORPION, EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.SUIT_HAMSTER],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 4,
      minimum: 40,
      frequency: 100,
      enemies: [EnemyType.SNAKE1, EnemyType.SNAKE2, EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 4.5,
      minimum: 70,
      frequency: 100,
      enemies: [EnemyType.SNAKE2, EnemyType.SNAKE1],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.SNAKE1],
      bosses: [],
      events: [],
    },
    {
      minute: 5.5,
      minimum: 20,
      frequency: 30,
      enemies: [EnemyType.CACTUS],
      events: [],
    },
    {
      minute: 6,
      minimum: 30,
      frequency: 30,
      enemies: [EnemyType.CACTUS],
      bosses: [],
      events: [],
    },
    {
      minute: 6.5,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.SCORPION],
      bosses: [EnemyType.SUIT_HAMSTER],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 7,
      minimum: 15,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 7.5,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 8,
      minimum: 40,
      frequency: 100,
      enemies: [EnemyType.VULTURE],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 8.5,
      minimum: 40,
      frequency: 100,
      enemies: [EnemyType.VULTURE],
      bosses: [EnemyType.LIZARD_HAMSTER],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 9,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2],
      events: [],
    },
    {
      minute: 9.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 10,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2],
      bosses: [EnemyType.DEATH],
      events: [],
    },
  ],

  //DESERT 5, 10 mins level
  [StageType.DESERT5]: [
    //scorpio party
    {
      stageNameKey: "stages.desert5.name",
      descriptionKey: "stages.desert5.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      startingSpawns: 3,
      minute: 0,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 10,
      frequency: 200,
      enemies: [EnemyType.SCORPION, EnemyType.SMALL_HAMSTER1],
      formations: [
        {
          enemyType: EnemyType.SCORPION,
          enemyCount: 27,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 6000,
          showPointerAfterMinute: 0,
        },
        {
          enemyType: EnemyType.SNAKE2,
          enemyCount: 30,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 10000,
          showPointerAfterMinute: 2,
        },
      ],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 1,
      minimum: 10,
      frequency: 50,
      enemies: [EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 1.5,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 2,
      minimum: 30,
      frequency: 20,
      enemies: [EnemyType.SCORPION, EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 2.5,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.SCORPION, EnemyType.SNAKE1],
      events: [],
    },
    {
      minute: 3,
      minimum: 40,
      frequency: 100,
      enemies: [EnemyType.SNAKE1, EnemyType.SCORPION, EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.SCORPION_BOSS],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 3.5,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SNAKE2],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 4,
      minimum: 30,
      frequency: 150,
      enemies: [EnemyType.SCORPION, EnemyType.SNAKE2, EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 4.5,
      minimum: 70,
      frequency: 100,
      enemies: [EnemyType.SNAKE2, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.SNAKE2, EnemyType.SCORPION],
      bosses: [EnemyType.SUIT_HAMSTER],
      events: [],
    },
    {
      minute: 5.5,
      minimum: 70,
      frequency: 30,
      enemies: [EnemyType.SNAKE2, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 6,
      minimum: 70,
      frequency: 30,
      enemies: [EnemyType.SNAKE2, EnemyType.SCORPION],
      bosses: [],
      events: [],
    },
    {
      minute: 6.5,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 7,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 7.5,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SCORPION],
      bosses: [EnemyType.SUIT_HAMSTER, EnemyType.SCORPION_BOSS],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 8,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.VULTURE],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 8.5,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.GOLEM, EnemyType.SCORPION],
      bosses: [],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 9,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 9.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 10,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.SCORPION],
      bosses: [EnemyType.DEATH],
      events: [],
    },
  ],
  [StageType.DESERT6]: [
    //outrun the rider, survive 12 mins
    {
      stageNameKey: "stages.desert6.name",
      descriptionKey: "stages.desert6.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      startingSpawns: 3,
      minute: 0,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 40,
      frequency: 200,
      enemies: [EnemyType.SMALL_HAMSTER1],
      formations: [
        {
          enemyType: EnemyType.SNAKE2,
          enemyCount: 27,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 12000,
          showPointerAfterMinute: 0,
        },
      ],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 20,
      frequency: 250,
      enemies: [EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.LIZARD_HAMSTER],
      events: [],
    },
    {
      minute: 1,
      minimum: 20,
      frequency: 250,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 1.5,
      minimum: 20,
      frequency: 200,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 2,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.SCORPION, EnemyType.SMALL_HAMSTER1],
      events: [],
    },
    {
      minute: 2.5,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 3,
      minimum: 40,
      frequency: 100,
      enemies: [EnemyType.SNAKE1, EnemyType.FAT_HAMSTER],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 3.5,
      minimum: 60,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SNAKE1],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 4,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.SNAKE2, EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.SUIT_HAMSTER, EnemyType.SUIT_HAMSTER],
      events: [],
    },
    {
      minute: 4.5,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.SNAKE2, EnemyType.SNAKE1],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.SNAKE2, EnemyType.SCORPION],
      bosses: [],
      events: [],
    },
    {
      minute: 5.5,
      minimum: 70,
      frequency: 30,
      enemies: [EnemyType.SNAKE2, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 6,
      minimum: 70,
      frequency: 30,
      enemies: [EnemyType.SNAKE2, EnemyType.VULTURE],
      bosses: [],
      events: [],
    },
    {
      minute: 6.5,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 7,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2],
      events: [],
    },
    {
      minute: 7.5,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2],
      bosses: [EnemyType.SCORPION_BOSS],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 8,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.VULTURE],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 8.5,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.GOLEM, EnemyType.CACTUS],
      bosses: [],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 9,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.CACTUS],
      events: [],
    },
    {
      minute: 9.5,
      minimum: 40,
      frequency: 100,
      enemies: [EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 10,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.GOLEM],
      bosses: [],
      events: [],
    },
    {
      minute: 10.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.GOLEM],
      bosses: [],
      events: [],
    },
    {
      minute: 11,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.GOLEM],
      bosses: [],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 2000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 11.5,
      minimum: 70,
      frequency: 20,
      enemies: [EnemyType.GOLEM],
      bosses: [],
      events: [],
    },
    {
      minute: 12,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.GOLEM],
      bosses: [EnemyType.DEATH],
      events: [],
    },
  ],
  [StageType.DESERT7]: [
    //green hell, survive 12 mins
    {
      stageNameKey: "stages.desert7.name",
      descriptionKey: "stages.desert1.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      startingSpawns: 3,
      minute: 0,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER],
      formations: [
        {
          enemyType: EnemyType.CACTUS,
          enemyCount: 12,
          radius: 150,
          rotationSpeed: 0.01,
          spawnDistance: 2000,
          showPointerAfterMinute: 1,
        },
        {
          enemyType: EnemyType.SNAKE2,
          enemyCount: 30,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 8000,
          showPointerAfterMinute: 2,
        },
      ],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.SNAKE1, EnemyType.SMALL_HAMSTER1],
      events: [],
    },
    {
      minute: 1,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SNAKE1, EnemyType.CACTUS],
      events: [],
    },
    {
      minute: 1.5,
      minimum: 40,
      frequency: 150,
      enemies: [EnemyType.CACTUS],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 2,
      minimum: 40,
      frequency: 100,
      enemies: [EnemyType.CACTUS, EnemyType.SNAKE1],
      events: [],
    },
    {
      minute: 2.5,
      minimum: 70,
      frequency: 20,
      enemies: [EnemyType.SNAKE1],
      events: [],
    },
    {
      minute: 3,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.CACTUS],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 3.5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.CACTUS],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 4,
      minimum: 60,
      frequency: 100,
      enemies: [EnemyType.SNAKE1, EnemyType.CACTUS],
      events: [],
      bosses: [EnemyType.GOLEM_BOSS],
    },
    {
      minute: 4.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.SNAKE2, EnemyType.CACTUS],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.SNAKE2, EnemyType.SNAKE1, EnemyType.CACTUS],
      bosses: [],
      events: [],
    },
    {
      minute: 5.5,
      minimum: 70,
      frequency: 30,
      enemies: [
        EnemyType.SNAKE2,
        EnemyType.SNAKE1,
        EnemyType.CACTUS,
        EnemyType.SCORPION,
      ],
      events: [],
    },
    {
      minute: 6,
      minimum: 70,
      frequency: 30,
      enemies: [
        EnemyType.SNAKE2,
        EnemyType.SNAKE1,
        EnemyType.CACTUS,
        EnemyType.SCORPION,
      ],
      bosses: [],
      events: [],
    },
    {
      minute: 6.5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.CACTUS],
      bosses: [EnemyType.SCORPION_BOSS, EnemyType.SUIT_HAMSTER],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 7,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.CACTUS],
      events: [],
    },
    {
      minute: 7.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.CACTUS, EnemyType.SNAKE2],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 8,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.VULTURE],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 8.5,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.GOLEM, EnemyType.CACTUS],
      bosses: [],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 9,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.CACTUS],
      events: [],
    },
    {
      minute: 9.5,
      minimum: 70,
      frequency: 100,
      enemies: [EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 10,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.GOLEM],
      bosses: [],
      events: [],
    },
    {
      minute: 10.5,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.WARRIOR_HAMSTER],
      bosses: [EnemyType.SCORPION_BOSS],
      events: [],
    },
    {
      minute: 11,
      minimum: 20,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 2000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 11.5,
      minimum: 70,
      frequency: 100,
      enemies: [EnemyType.GOLEM, EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 12,
      minimum: 70,
      frequency: 100,
      enemies: [EnemyType.GOLEM, EnemyType.WARRIOR_HAMSTER],
      bosses: [EnemyType.DEATH],
      events: [],
    },
  ],
  [StageType.DESERT8]: [
    //original level 2, survive 15 mins
    {
      stageNameKey: "stages.desert2.name",
      descriptionKey: "stages.desert2.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      minute: 0,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER],
      bosses: [],
      startingSpawns: 10,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 30,
      formations: [
        {
          enemyType: EnemyType.GOLEM,
          enemyCount: 17,
          radius: 200,
          rotationSpeed: 0.01,
          spawnDistance: 500,
          showPointerAfterMinute: 0,
        },
        {
          enemyType: EnemyType.VULTURE,
          enemyCount: 27,
          radius: 250,
          rotationSpeed: 0.01,
          spawnDistance: 8000,
          showPointerAfterMinute: 2,
        },
      ],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 50,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SNAKE1],
      events: [],
    },
    {
      minute: 1,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.CACTUS],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 1.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.CACTUS],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 2,
      minimum: 50,
      frequency: 20,
      enemies: [EnemyType.SCORPION, EnemyType.CACTUS],
      events: [],
    },
    {
      minute: 2.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.LIZARD_HAMSTER],
      events: [],
    },
    {
      minute: 3,
      minimum: 40,
      frequency: 20,
      enemies: [EnemyType.CACTUS],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 3.5,
      minimum: 25,
      frequency: 50,
      enemies: [EnemyType.SNAKE1, EnemyType.CACTUS],
      bosses: [EnemyType.VAMPIRE_HAMSTER],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 4,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.GOLEM, EnemyType.CACTUS],
      events: [],
    },
    {
      minute: 4.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.SNAKE2, EnemyType.SNAKE1, EnemyType.CACTUS],
      bosses: [],
      events: [],
    },
    {
      minute: 5.5,
      minimum: 70,
      frequency: 30,
      enemies: [
        EnemyType.SNAKE2,
        EnemyType.SNAKE1,
        EnemyType.CACTUS,
        EnemyType.SCORPION,
      ],
      events: [],
    },
    {
      minute: 6,
      minimum: 70,
      frequency: 30,
      enemies: [
        EnemyType.SNAKE2,
        EnemyType.SNAKE1,
        EnemyType.CACTUS,
        EnemyType.SCORPION,
      ],
      bosses: [],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 6.5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.VULTURE],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 7,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.VULTURE],
      bosses: [EnemyType.SCORPION_BOSS],
      events: [],
    },
    {
      minute: 7.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.VULTURE],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 8,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.CACTUS],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 8.5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.CACTUS],
      bosses: [EnemyType.SUIT_HAMSTER],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 9,
      minimum: 40,
      frequency: 100,
      enemies: [EnemyType.GOLEM],
      events: [],
    },
    {
      minute: 9.5,
      minimum: 70,
      frequency: 100,
      enemies: [EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 10,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.GOLEM],
      bosses: [],
      events: [],
    },
    {
      minute: 10.5,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 11,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 2000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 11.5,
      minimum: 50,
      frequency: 100,
      enemies: [EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 12,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.WARRIOR_HAMSTER],
      bosses: [EnemyType.GOLEM_BOSS],
      events: [],
    },
    {
      minute: 12.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 13,
      minimum: 70,
      frequency: 100,
      enemies: [EnemyType.GOLEM, EnemyType.WARRIOR_HAMSTER, EnemyType.SNAKE2],
      bosses: [],
      events: [],
    },
    {
      minute: 13.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.WARRIOR_HAMSTER, EnemyType.SNAKE2],
      bosses: [],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 14,
      minimum: 30,
      frequency: 150,
      enemies: [EnemyType.GOLEM, EnemyType.REPTILE],
      bosses: [],
      events: [],
    },
    {
      minute: 14.5,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.GOLEM, EnemyType.REPTILE],
      bosses: [],
      events: [],
    },
    {
      minute: 15,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.GOLEM, EnemyType.REPTILE],
      bosses: [EnemyType.DEATH],
      events: [],
    },
  ],
  [StageType.DESERT9]: [
    //original level 3
    {
      stageNameKey: "stages.desert3.name",
      descriptionKey: "stages.desert3.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      minute: 0,
      frequency: 100,
      enemies: [EnemyType.SCORPION],
      bosses: [],
      startingSpawns: 3,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 30,
      minimum: 30,
      formations: [
        {
          enemyType: EnemyType.REPTILE,
          enemyCount: 30,
          radius: 200,
          rotationSpeed: 0.01,
          spawnDistance: 10000,
          showPointerAfterMinute: 2.5,
        },
      ],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.CACTUS],
      events: [],
    },
    {
      minute: 1,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.CACTUS],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 1.5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.SNAKE2, EnemyType.CACTUS, EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 2,
      minimum: 50,
      frequency: 20,
      enemies: [EnemyType.SCORPION, EnemyType.SNAKE1],
      bosses: [
        EnemyType.LIZARD_HAMSTER,
        EnemyType.LIZARD_HAMSTER,
        EnemyType.LIZARD_HAMSTER,
      ],
      events: [],
    },
    {
      minute: 2.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 3,
      minimum: 50,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.WARRIOR_HAMSTER],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 3.5,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 4,
      minimum: 20,
      frequency: 100,
      enemies: [EnemyType.GOLEM],
      events: [],
    },
    {
      minute: 4.5,
      minimum: 70,
      frequency: 100,
      enemies: [EnemyType.VULTURE],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 5,
      minimum: 60,
      frequency: 500,
      enemies: [EnemyType.CACTUS, EnemyType.VULTURE, EnemyType.SNAKE2],
      bosses: [],
      events: [],
    },
    {
      minute: 5.5,
      minimum: 50,
      frequency: 100,
      enemies: [EnemyType.CACTUS, EnemyType.VULTURE, EnemyType.SNAKE2],
      events: [],
    },
    {
      minute: 6,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2, EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 6.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2, EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 7,
      minimum: 50,
      frequency: 20,
      enemies: [
        EnemyType.VULTURE,
        EnemyType.SNAKE2,
        EnemyType.GOLEM,
        EnemyType.SCORPION,
      ],
      events: [],
    },
    {
      minute: 7.5,
      minimum: 70,
      frequency: 50,
      enemies: [
        EnemyType.VULTURE,
        EnemyType.SNAKE2,
        EnemyType.GOLEM,
        EnemyType.SCORPION,
      ],
      bosses: [],
      events: [],
    },
    {
      minute: 8,
      minimum: 40,
      frequency: 20,
      enemies: [EnemyType.VULTURE, EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 8.5,
      minimum: 25,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.FAT_HAMSTER],
      bosses: [EnemyType.KING_HAMSTER],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 9,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 9.5,
      minimum: 40,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 10,
      minimum: 60,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 10.5,
      minimum: 50,
      frequency: 100,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.VULTURE],
      events: [],
    },
    {
      minute: 11,
      minimum: 30,
      frequency: 50,
      enemies: [
        EnemyType.WARRIOR_HAMSTER,
        EnemyType.SCORPION,
        EnemyType.VULTURE,
      ],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 11.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 12,
      minimum: 50,
      frequency: 20,
      enemies: [
        EnemyType.WARRIOR_HAMSTER,
        EnemyType.SCORPION,
        EnemyType.VULTURE,
      ],
      events: [],
    },
    {
      minute: 12.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.VULTURE],
      bosses: [],
      events: [],
    },
    {
      minute: 13,
      minimum: 40,
      frequency: 20,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.VULTURE],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 13.5,
      minimum: 25,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.GOLEM],
      bosses: [],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 14,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.REPTILE, EnemyType.VULTURE, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 14.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.REPTILE, EnemyType.VULTURE, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 15,
      minimum: 60,
      frequency: 100,
      enemies: [EnemyType.REPTILE, EnemyType.VULTURE, EnemyType.SCORPION],
      bosses: [EnemyType.DEATH],
      events: [],
    },
  ],
  [StageType.DESERT10]: [
    //only bosses
    {
      stageNameKey: "stages.desert1.name",
      descriptionKey: "stages.desert1.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      startingSpawns: 1,
      minute: 0,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 10,
      frequency: 250,
      enemies: [EnemyType.FAT_HAMSTER],
      formations: [],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 10,
      frequency: 100,
      enemies: [],
      bosses: [EnemyType.SUIT_HAMSTER, EnemyType.SUIT_HAMSTER],
      events: [],
    },
    {
      minute: 1,
      minimum: 10,
      frequency: 100,
      enemies: [],
      bosses: [],
      events: [],
    },
    {
      minute: 1.5,
      minimum: 20,
      frequency: 150,
      enemies: [],
      bosses: [EnemyType.LIZARD_HAMSTER, EnemyType.LIZARD_HAMSTER],
      events: [],
    },
    {
      minute: 2,
      minimum: 20,
      frequency: 150,
      enemies: [],
      bosses: [],
      events: [],
    },
    {
      minute: 2.5,
      minimum: 15,
      frequency: 150,
      enemies: [],
      bosses: [EnemyType.SCORPION_BOSS, EnemyType.SCORPION_BOSS],
      events: [],
    },
    {
      minute: 3,
      minimum: 15,
      frequency: 100,
      enemies: [],
      events: [],
    },
    {
      minute: 3.5,
      minimum: 20,
      frequency: 100,
      enemies: [],
      bosses: [EnemyType.GOLEM_BOSS, EnemyType.VAMPIRE_HAMSTER],
      events: [],
    },
    {
      minute: 4,
      minimum: 10,
      frequency: 500,
      enemies: [],
      bosses: [],
      events: [],
    },
    {
      minute: 4.5,
      minimum: 10,
      frequency: 500,
      enemies: [],
      bosses: [],
      events: [],
    },
    {
      minute: 5,
      minimum: 10,
      frequency: 500,
      enemies: [],
      events: [],
      bosses: [EnemyType.DEATH],
    },
  ],
  [StageType.DESERT11]: [
    //long, 22 mins
    {
      stageNameKey: "stages.desert2.name",
      descriptionKey: "stages.desert2.description",
      imageKey: "desert_background",
      unlocked: true,
      hidden: false,
      minute: 0,
      frequency: 100,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
      startingSpawns: 10,
      destructibleType: DestructibleType.GIFT,
      destructibleFreq: 1000,
      destructibleChance: 10,
      destructibleChanceMax: 50,
      maxDestructibles: 20,
      minimum: 30,
      formations: [],
      events: [],
    },
    {
      minute: 0.5,
      minimum: 50,
      frequency: 100,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [],
    },
    {
      minute: 1,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 1.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.FAT_HAMSTER, EnemyType.SNAKE1],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 2,
      minimum: 50,
      frequency: 20,
      enemies: [EnemyType.SNAKE1],
      events: [],
    },
    {
      minute: 2.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.SNAKE1],
      bosses: [],
      events: [],
    },
    {
      minute: 3,
      minimum: 40,
      frequency: 20,
      enemies: [EnemyType.CACTUS, EnemyType.SNAKE1],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 3.5,
      minimum: 25,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.SCORPION],
      bosses: [],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 4,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.CACTUS, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 4.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.CACTUS, EnemyType.VULTURE, EnemyType.SNAKE2],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 5,
      minimum: 60,
      frequency: 500,
      enemies: [EnemyType.CACTUS, EnemyType.VULTURE, EnemyType.SNAKE2],
      bosses: [],
      events: [],
    },
    {
      minute: 5.5,
      minimum: 50,
      frequency: 100,
      enemies: [EnemyType.CACTUS, EnemyType.VULTURE, EnemyType.SNAKE2],
      events: [],
    },
    {
      minute: 6,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2, EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 6.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.SNAKE2, EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 7,
      minimum: 50,
      frequency: 20,
      enemies: [
        EnemyType.VULTURE,
        EnemyType.SNAKE2,
        EnemyType.GOLEM,
        EnemyType.SCORPION,
      ],
      events: [],
    },
    {
      minute: 7.5,
      minimum: 70,
      frequency: 50,
      enemies: [
        EnemyType.VULTURE,
        EnemyType.SNAKE2,
        EnemyType.GOLEM,
        EnemyType.SCORPION,
      ],
      bosses: [],
      events: [],
    },
    {
      minute: 8,
      minimum: 40,
      frequency: 20,
      enemies: [EnemyType.VULTURE, EnemyType.GOLEM],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 8.5,
      minimum: 25,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.GOLEM],
      bosses: [],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 9,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.VULTURE, EnemyType.GOLEM, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 9.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.VULTURE, EnemyType.GOLEM, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 10,
      minimum: 60,
      frequency: 500,
      enemies: [EnemyType.VULTURE, EnemyType.GOLEM, EnemyType.SCORPION],
      bosses: [],
      events: [],
    },
    {
      minute: 10.5,
      minimum: 50,
      frequency: 100,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 11,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 11.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 12,
      minimum: 50,
      frequency: 20,
      enemies: [
        EnemyType.WARRIOR_HAMSTER,
        EnemyType.SCORPION,
        EnemyType.VULTURE,
      ],
      events: [],
    },
    {
      minute: 12.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.VULTURE],
      bosses: [],
      events: [],
    },
    {
      minute: 13,
      minimum: 40,
      frequency: 20,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.VULTURE],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 13.5,
      minimum: 25,
      frequency: 50,
      enemies: [EnemyType.WARRIOR_HAMSTER, EnemyType.VULTURE],
      bosses: [],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 14,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.REPTILE, EnemyType.VULTURE, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 14.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.REPTILE, EnemyType.VULTURE, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 15,
      minimum: 60,
      frequency: 500,
      enemies: [EnemyType.REPTILE, EnemyType.VULTURE, EnemyType.SCORPION],
      bosses: [],
      events: [],
    },
    {
      minute: 15.5,
      minimum: 50,
      frequency: 100,
      enemies: [EnemyType.REPTILE, EnemyType.VULTURE, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 16,
      minimum: 30,
      frequency: 50,
      enemies: [EnemyType.REPTILE, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 16.5,
      minimum: 50,
      frequency: 50,
      enemies: [EnemyType.REPTILE, EnemyType.SCORPION],
      events: [
        {
          eventType: StageEventType.HAMSTER_SWARM,
          delay: 5000,
          repeat: 5,
          chance: 60,
        },
      ],
    },
    {
      minute: 17,
      minimum: 50,
      frequency: 20,
      enemies: [EnemyType.REPTILE, EnemyType.SCORPION],
      events: [],
    },
    {
      minute: 17.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.REPTILE, EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [],
    },
    {
      minute: 18,
      minimum: 40,
      frequency: 20,
      enemies: [EnemyType.REPTILE, EnemyType.WARRIOR_HAMSTER],
      events: [
        {
          eventType: StageEventType.VULTURE_SWARM,
          delay: 1500,
          repeat: 15,
          chance: 70,
        },
      ],
    },
    {
      minute: 18.5,
      minimum: 25,
      frequency: 50,
      enemies: [EnemyType.REPTILE, EnemyType.WARRIOR_HAMSTER],
      bosses: [],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 3000,
          repeat: 10,
          chance: 50,
        },
      ],
    },
    {
      minute: 19,
      minimum: 30,
      frequency: 100,
      enemies: [EnemyType.REPTILE, EnemyType.WARRIOR_HAMSTER],
      events: [],
    },
    {
      minute: 19.5,
      minimum: 70,
      frequency: 50,
      enemies: [EnemyType.REPTILE],
      events: [
        {
          eventType: StageEventType.SCORPION_SWARM,
          delay: 2000,
          repeat: 15,
          chance: 50,
        },
      ],
    },
    {
      minute: 20,
      minimum: 60,
      frequency: 500,
      enemies: [EnemyType.REPTILE],
      bosses: [],
      events: [],
    },
    {
      minute: 21,
      minimum: 60,
      frequency: 500,
      enemies: [EnemyType.REPTILE],
      bosses: [],
      events: [],
    },
    {
      minute: 22,
      minimum: 60,
      frequency: 500,
      enemies: [EnemyType.REPTILE],
      bosses: [EnemyType.DEATH],
      events: [],
    },
  ],
  [StageType.GREEN1]: [
    {
      stageNameKey: "stages.green1.name",
      descriptionKey: "stages.green1.description",
      imageKey: "green_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],

  //Levels are not yet implemented
  [StageType.JUNGLE1]: [
    {
      stageNameKey: "stages.jungle1.name",
      descriptionKey: "stages.jungle1.description",
      imageKey: "jungle_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.JUNGLE2]: [
    {
      stageNameKey: "stages.jungle2.name",
      descriptionKey: "stages.jungle2.description",
      imageKey: "jungle_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.JUNGLE3]: [
    {
      stageNameKey: "stages.jungle3.name",
      descriptionKey: "stages.jungle3.description",
      imageKey: "jungle_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.CITY1]: [
    {
      stageNameKey: "stages.city1.name",
      descriptionKey: "stages.city1.description",
      imageKey: "city_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.CITY2]: [
    {
      stageNameKey: "stages.city2.name",
      descriptionKey: "stages.city2.description",
      imageKey: "city_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.CITY3]: [
    {
      stageNameKey: "stages.city3.name",
      descriptionKey: "stages.city3.description",
      imageKey: "city_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.CYBERPUNK1]: [
    {
      stageNameKey: "stages.cyberpunk1.name",
      descriptionKey: "stages.cyberpunk1.description",
      imageKey: "cyberpunk_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.CYBERPUNK2]: [
    {
      stageNameKey: "stages.cyberpunk2.name",
      descriptionKey: "stages.cyberpunk2.description",
      imageKey: "cyberpunk_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.CYBERPUNK3]: [
    {
      stageNameKey: "stages.cyberpunk3.name",
      descriptionKey: "stages.cyberpunk3.description",
      imageKey: "cyberpunk_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.METAVERSE1]: [
    {
      stageNameKey: "stages.metaverse1.name",
      descriptionKey: "stages.metaverse1.description",
      imageKey: "metaverse_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.METAVERSE2]: [
    {
      stageNameKey: "stages.metaverse2.name",
      descriptionKey: "stages.metaverse2.description",
      imageKey: "metaverse_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
  [StageType.METAVERSE3]: [
    {
      stageNameKey: "stages.metaverse3.name",
      descriptionKey: "stages.metaverse3.description",
      imageKey: "metaverse_background",
      unlocked: false,
      hidden: false,
      minute: 0,
      frequency: 1000,
      enemies: [EnemyType.SMALL_HAMSTER1],
      bosses: [],
    },
  ],
};

// Merge external stage packs (green stages) into the base STAGES map
Object.assign(STAGES_UNSAFE, STAGES_GREEN);

const STAGES = STAGES_UNSAFE as Record<StageType, StageData[]>;

export default STAGES;
